import ApplicationReports from "./ApplicationReports";

const PendingApplications = () => {
  return(
    <ApplicationReports status="2" title="District Document Pending Applications Report" heading="Document Pending Applications"></ApplicationReports>
  )
};

export default PendingApplications;
